import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useLocalStore from 'src/store/useLocalStore';
import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { AutoConnectCameraStatus } from 'src/models/Camera.model';
import CameraConnection from 'src/models/Camera/CameraConnection';
import { I18NextNS } from 'src/models/Language.model';

import { captureError } from 'src/utils/errorReporting';

const useAutoConnectCamera = () => {
  const { cameraIP } = useLocalStore();
  const { setCameraData, setAutoConnectCameraStatus } = useRemoteBoundStore();

  const { t } = useTranslation(I18NextNS.COMMON);

  const autoConnectCamera = useCallback(async () => {
    try {
      if (cameraIP) {
        setAutoConnectCameraStatus(AutoConnectCameraStatus.CONNECTING);
        const cameraData = await CameraConnection.loadCameraData(
          cameraIP,
          t('message.error.cameraIpMissingMsg'),
        );
        await CameraConnection.getInstance().say(
          'Camera successfully connected.',
        );
        setCameraData(cameraData);
        setAutoConnectCameraStatus(AutoConnectCameraStatus.CONNECTED);
      } else {
        setAutoConnectCameraStatus(AutoConnectCameraStatus.FAILED);
      }
    } catch (error) {
      setAutoConnectCameraStatus(AutoConnectCameraStatus.FAILED);

      captureError(
        error,
        'Failed to connect to the camera using the existing IP address',
      );
    }
  }, [cameraIP, setAutoConnectCameraStatus, setCameraData, t]);

  return { autoConnectCamera };
};

export default useAutoConnectCamera;
